import React, { useState, useContext, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import StoreContext from '../../store/Context'
import api from '../../services/api'
import messages from '../../services/messages'
import { useDispatch } from 'react-redux'
import { setAvailabilities } from '../../redux/availabilities/actions'
import { setFeatures } from '../../redux/features/actions'
import { setCompany } from '../../redux/company/actions'
import { setPermissions } from '../../redux/permissions/actions'
import { setProfiles } from '../../redux/profiles/actions'
import { setRoles } from '../../redux/roles/actions'
import { setUser } from '../../redux/user/actions'
import CircularProgress from '../../components/atoms/feedback/circularProgress'

const SigninSSO = () => {
  const { data: dataParams } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { setToken } = useContext(StoreContext)

  useEffect(() => {
    setLoading(true)
    setToken(null)
    localStorage.removeItem('token')
    localStorage.removeItem('state')
    dispatch({ type: 'LOGOUT' })

    api({
      method: 'POST',
      url: '/login',
      data: {},
      headers: { Authorization: `Bearer ${dataParams}` },
    })
      .then((response) => {
        setLoading(false)
        let data = response.data.data
        api.defaults.headers.common['Authorization'] = data.Authorization
        messages.defaults.headers.common['Authorization'] = data.Authorization
        setToken(data.Authorization)
        dispatch(setAvailabilities(data.availabilities))
        dispatch(setFeatures(data.features))
        dispatch(setCompany(data.company))
        dispatch(setFeatures(data.features))
        dispatch(setPermissions(data.permissions))
        dispatch(setProfiles(data.profiles))
        dispatch(setRoles(data.roles))
        dispatch(setUser(data.user))
        localStorage.setItem('rememberMe', data.user.email)
        return history.push('/dashboard')
      })
      .catch((error) => {
        setLoading(false)
        if (error?.response?.data) {
          enqueueSnackbar(t(`toasts.genericError`), {
            variant: 'error',
          })
        }
      })

    setTimeout(() => {
      setLoading(false)
      history.push('/dashboard')
    }, 1000)
  }, [dataParams, dispatch, history, t])

  return (
    loading && (
      <div style={{ width: '100%', textAlign: 'center', padding: 50 }}>
        <CircularProgress size={16} />
        <div style={{ marginTop: 10 }}>{t('alerts.redirectSSO')}</div>
      </div>
    )
  )
}

export default SigninSSO
